import { render, staticRenderFns } from "./LogAndReg.vue?vue&type=template&id=3f2093b2&"
import script from "./LogAndReg.vue?vue&type=script&lang=js&"
export * from "./LogAndReg.vue?vue&type=script&lang=js&"
import style0 from "./LogAndReg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports